import Legend from './Legend.ts.vue';
import LegendLabel from './LegendLabel.ts.vue';
export default [
    Legend,
    LegendLabel,
];
